module.exports = __webpack_public_path__ + "img/сian.dac086c2.svg";